import React from 'react'
import { useParams } from 'react-router-dom'

const withParams = WrappedComponent => {
  return props => {
    const params = useParams()
    const { parentId } = params

    return <WrappedComponent parentId={parentId} {...props} />
  }
}

export default withParams
